<template>
  <div class="mt-4 mb-5">
    <!-- Basic Details - Start -->
    <div class="row">
      <div class="col-12 pr-5 pl-5 mt-4">
        <div class="row">
          <div class="col-md-6">
            <span class="mr-3 align-middle col-mb heading-text">
                <i class="fa fa-lock mr-2"/>WP Admin Page Lock
            </span>
            <span class="badge badge-success" v-if="envType === 'live'">LIVE</span>
            <span class="badge bg-violate" v-else>Staging</span>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-6">
            <div class="form-group">
              <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : isAdminLocked === 'on', 'bootstrap-switch-off bootstrap-switch-focused' : isAdminLocked === 'off' }">
                <div class="bootstrap-switch-container" @click="toggleAdminLock">
                  <span class="bootstrap-switch-handle-on bootstrap-switch-primary">On</span>
                  <span class="bootstrap-switch-label"></span>
                  <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                </div>
              </div>
              <label class="ml-2" style="font-size: 14px;">
                Do you want to enable WP admin page lock?
              </label>
            </div>
          </div>
        </div>
        <div v-if="loading === 'toggleSecurity'"  class="loader" style="margin: 0 auto !important;"></div>
        <section v-else-if="isAdminLocked === 'on'">
          <div class="row mt-3">
            <div class="col-md-6">
              <h3>Access Users For WP Admin Page</h3>
            </div>
            <div class="col-md-6">
              <button class="btn btn-primary pull-right" @click="openAdminModal">Add New Access User</button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" >
              <div v-if="adminLockList.length <= 0">
              <span class="text-danger ">
                No Access Users to show here...
              </span>
              </div>
              <div v-else class="table-responsive">
                <table class="table table-striped ">
                  <thead class="text-primary">
                  <tr>
                    <th>Username</th>
                    <th>Password</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(admin, index) in adminLockList" :key="index">
                    <td><small><b>{{admin.username}}</b></small></td>
                    <td><small><b>{{ admin.password }}</b></small></td>
                    <td>
                      <div v-if="loading===admin.username" class="loader" style="width: 20px;height: 20px; margin: 0 0 !important;"></div>
                      <span v-else><span class="btn btn-sm btn-danger" v-on:click="removeAdmin(admin)"><i class="fa fa-trash"></i></span></span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <add-admin-modal ref="addAdmin" />
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import addAdminModal from "./addAdminModal";
import adminLogs from "@/mixins/adminLogs";
export default {
name: "AdminLock",
  props: {
    account: {
      type: Object,
      required: true
    },
    envType: {
      type: String,
      required: true
    },
    fromCollaborator: {
      type: Boolean,
      required: false
    },
    supervisor: {
      type: Object,
      required: false
    }
  },
  data () {
   return {
     loading: null,
     isAdminLocked: 'off',
     adminLockList: [],
     selectedMainAcc: null
   }
  },
  components: {
    addAdminModal
  },
  computed: {
    uid () {
      return (this.fromCollaborator) ? this.supervisor.supervisorId : this.$store.getters.user.uid;
    },
    domain () {
      return this.selectedMainAcc.domain
    }
  },
  watch: {
    envType(val) {
      if(val === 'live'){
        this.selectedMainAcc = this.account;
      }else{
        this.selectedMainAcc = this.account.staging;
      }
    },
    account(){
      if(this.envType === 'live'){
        this.selectedMainAcc = this.account;
      }else{
        this.selectedMainAcc = this.account.staging;
      }
    },
    selectedMainAcc () {
      this.fetchData();
    }
  },
  mounted () {
    if(this.envType === 'live'){
      this.selectedMainAcc = this.account;
    }else{
      this.selectedMainAcc = this.account.staging;
    }
    this.fetchData();
  },
  methods: {
    openAdminModal () {
      this.$refs.addAdmin.load()
    },
    fetchData () {
      this.isAdminLocked = (this.selectedMainAcc && this.selectedMainAcc.isAdminLocked) ? this.selectedMainAcc.isAdminLocked : 'off';
      this.adminLockList = (this.selectedMainAcc && this.selectedMainAcc.adminLockList) ? this.selectedMainAcc.adminLockList : [];
    },
    async toggleAdminLock () {
      try {
        this.loading = 'toggleSecurity'
        this.isAdminLocked = (this.isAdminLocked === 'off') ? 'on' : 'off'
        await this.$http.post(`security/${this.isAdminLocked}`, {
              ip: this.selectedMainAcc.ftp.host,
              domain: this.domain,
              grant_type: "token",
            });
        const accountRef = await db.collection('hostingAccounts').doc(this.uid).get();
        const { accounts } = accountRef.data();
        const beforePayload = JSON.parse(JSON.stringify(accounts))
        const cAccount = accounts[this.account.planIndex];
        let accountObject = {}
        if (this.account.addonIndex !== null) {
          accountObject = cAccount.addon[this.account.addonIndex]
        } else {
          accountObject = cAccount.primary
        }
        if (this.envType === 'live') {
          accountObject.isAdminLocked = this.isAdminLocked
        } else {
          accountObject.staging.isAdminLocked = this.isAdminLocked
        }
        await this.addHostingAccountEventLog({hostingAccountId : this.uid ,  afterPayload: accounts ,  beforePayload : beforePayload, action: 'Toggle Admin Lock'})
        await db.collection('hostingAccounts').doc(this.uid).update({
          accounts
        });
        swal({
          title: "Success!",
          text: `Successfully turned ${this.isAdminLocked} security for this domain`,
          type: "success",
        });
      } catch (e) {
        this.isAdminLocked = (this.isAdminLocked === 'off') ? 'on' : 'off'
        swal({
          title: "Something went wrong!",
          text: `Error in turning ${this.isAdminLocked} security for this domain`,
          type: "error",
        });
      }
      this.loading = null
    },
    async addAdmin (data) {
      try {
        const userExist = this.adminLockList.some((admin)=>{
          return admin.username === data.username
        });
        console.log(userExist)
        if (userExist) {
          return swal({
            title: "Error!",
            text: `User already exist.`,
            type: "error",
          });
        }

        await this.$http.post('security/add-new-admin', {
          ip: this.selectedMainAcc.ftp.host,
          domain: this.domain,
          username: data.username,
          password: data.password,
          grant_type: "token",
        });
        this.adminLockList.push({
          username: data.username,
          password: data.password
        })
        const accountRef = await db.collection('hostingAccounts').doc(this.uid).get();
        const { accounts } = accountRef.data();
        const beforePayload = JSON.parse(JSON.stringify(accounts))
        const cAccount = accounts[this.account.planIndex];
        let accountObject = {}
        if (this.account.addonIndex !== null) {
          accountObject = cAccount.addon[this.account.addonIndex]
        } else {
          accountObject = cAccount.primary
        }
        if (this.envType === 'live') {
          accountObject.adminLockList = this.adminLockList
        } else {
          accountObject.staging.adminLockList = this.adminLockList
        }
        await this.addHostingAccountEventLog({hostingAccountId : this.uid ,  afterPayload: accounts , beforePayload : beforePayload, action: 'Add Admin'})
        await db.collection('hostingAccounts').doc(this.uid).update({
          accounts
        });
        swal({
          title: "Success!",
          text: `Successfully Added a new admin.`,
          type: "success",
        });
      } catch (e) {
        console.log(e.toString());
        swal({
          title: "Something went wrong!",
          text: `Error in adding new Admin`,
          type: "error",
        });
      }
    },
    async removeAdmin (admin){
      try {
        this.loading = admin.username
        await this.$http.post('security/remove-admin', {
          ip: this.selectedMainAcc.ftp.host,
          domain: this.domain,
          username: admin.username,
          grant_type: "token",
        });
        console.log(this.adminLockList.indexOf(admin))
        this.adminLockList.splice(this.adminLockList.indexOf(admin), 1)
        const accountRef = await db.collection('hostingAccounts').doc(this.uid).get();
        const { accounts } = accountRef.data();
        const beforePayload = JSON.parse(JSON.stringify(accounts))
        const cAccount = accounts[this.account.planIndex];
        let accountObject = {}
        if (this.account.addonIndex !== null) {
          accountObject = cAccount.addon[this.account.addonIndex]
        } else {
          accountObject = cAccount.primary
        }
        if (this.envType === 'live') {
          accountObject.adminLockList = this.adminLockList
        } else {
          accountObject.staging.adminLockList = this.adminLockList
        }
        await this.addHostingAccountEventLog({hostingAccountId : this.uid ,  afterPayload: accounts , beforePayload : beforePayload,  action: 'Remove Admin'})
        await db.collection('hostingAccounts').doc(this.uid).update({
          accounts
        });
        swal({
          title: "Success!",
          text: `Successfully turned ${this.isAdminLocked} security for this domain`,
          type: "success",
        });
      } catch (e) {
        console.log(e.toString());
        swal({
          title: "Something went wrong!",
          text: `Error in turning ${this.isAdminLocked} security for this domain`,
          type: "error",
        });
      }
      this.loading = null
    },
  }
}
</script>

<style scoped>

</style>
